import {format, parse} from "date-fns";


export const formatDate = jsDate =>
    (jsDate === undefined || jsDate === null) ? null : format(jsDate, 'yyyy-MM-dd')

export const parseDate = yyyyMMdd =>
    yyyyMMdd == null ? null : parse(yyyyMMdd, 'yyyy-MM-dd', new Date())



export function readAndParseItsDangerousCookie(cookieName) {

    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        const match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1].replace(/^"|"$/g, '') : null;
    }

    const urlSafeAtob = s => atob(
        s.replace(/_/g, '+').replace(/-/g, '/')
    )

    const cookieString = getCookie(cookieName)

    if(!cookieString) {
        return null
    }

    const parts = cookieString.split('.');

    if (parts.length !== 3) {
      throw new Error(`Invalid cookie format : '${cookieString}'`);
    }

    const decodedTimestampBytes = urlSafeAtob(parts[1])
    const decodedPayload = urlSafeAtob(parts[0])

    const parsedData = JSON.parse(decodedPayload)

    // Convert base64-decoded bytes to an integer (Unix timestamp)
    let signatureTime = 0;
    for (let i = 0; i < decodedTimestampBytes.length; i++) {
      signatureTime = (signatureTime << 8) | decodedTimestampBytes.charCodeAt(i);
    }

    const d = new Date(signatureTime)
    return {
        ...parsedData,
        toString: () => `Session(sigTime: ${signatureTime}, ${format(d, 'yyyy-M-d H:m:s')})`,
    }
}
